import FbIcon from '../../assets/images/fb.png'
import LinIcon from '../../assets/images/lin.png'
import InsIcon from '../../assets/images/gg.png'

export { FbIcon, LinIcon, InsIcon }
export * from 'react-icons/fa'